// extracted by mini-css-extract-plugin
export default {"fullScreenWrapper":"Hz6E2hBQIzfDfVQm62pX"};